import getBoostStats from "@casino/actions/Games/getBoostStats";
import optInToBoost from "@casino/actions/Games/optInToBoost";
import { useEffect, useState } from "react";

type Args = {
  eventId: string;
  gameId?: string;
  currency?: string;
  isOptedIn: boolean;
};

const POLL_INTERVAL_MS = 5_000;

const useBoostOptIn = ({ eventId, gameId, currency, isOptedIn }: Args) => {
  const [isOn, setIsOn] = useState(isOptedIn);
  const [isPending, setIsPending] = useState(false);
  const [freshTimerEndAt, setFreshTimerEndAt] = useState<string | undefined>(
    undefined,
  );
  const [winAmountDisplay, setWinAmountDisplay] = useState<string | undefined>(
    undefined,
  );
  const [boostAmountDisplay, setBoostAmountDisplay] = useState<
    string | undefined
  >(undefined);

  useEffect(() => {
    if (!isOn || !gameId) return;

    let isCancelled = false;
    const poll = async () => {
      const stats = await getBoostStats({ gameId });
      if (isCancelled || !stats) return;
      setWinAmountDisplay(stats.winAmountDisplay);
      setBoostAmountDisplay(stats.boostAmountDisplay);
    };

    const interval = setInterval(poll, POLL_INTERVAL_MS);
    return () => {
      isCancelled = true;
      clearInterval(interval);
    };
  }, [isOn, gameId]);

  const handleOptIn = async () => {
    if (isPending || isOn) return;

    setIsPending(true);
    const result = await optInToBoost({ eventId, currency });
    setIsPending(false);

    if (result.errors.length) return;

    setIsOn(true);
    setFreshTimerEndAt(result.timerEndAt);
  };

  return {
    isOptedIn: isOn,
    isPending,
    handleOptIn,
    timerEndAt: freshTimerEndAt,
    winAmountDisplay,
    boostAmountDisplay,
  };
};

export default useBoostOptIn;
